import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark";

type ThemeState = {
  mode: ThemeMode;
  toggleMode: () => void;
};

function systemPreferredMode(): ThemeMode {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: systemPreferredMode(),
      toggleMode: () => set({ mode: get().mode === "dark" ? "light" : "dark" }),
    }),
    { name: "ebook-studio-theme" },
  ),
);
